import {
  DietSettingsConnectorApollo,
  SaveMacroConnectorApollo,
} from '@front-activerse/common-components';
import DietSettingsQuery from '../DietSettings/graphql/DietSettingsQuery';
import MacroSettingsContainer from './MacroSettingsContainer';

const MacroSettingsPage: React.FC = () => {
  return (
    <DietSettingsConnectorApollo query={DietSettingsQuery}>
      {({ ...dietSettingsData }) => (
        <SaveMacroConnectorApollo>
          {({ saveMacro }: { saveMacro: (input: any) => Promise<any> }) => {
            return <MacroSettingsContainer {...dietSettingsData} saveMacro={saveMacro} />;
          }}
        </SaveMacroConnectorApollo>
      )}
    </DietSettingsConnectorApollo>
  );
};

export default MacroSettingsPage;
